import React from "react";
import { Helmet } from "react-helmet";

function Coimbatore() {
  return (
    <div style={{ padding: "20px" }}>
      <Helmet>
        <title>Professional Catering Services in Coimbatore | Wedding & Corporate</title>
        <meta
          name="description"
          content="Sevvur Pandiyan Catering provides professional catering services in Coimbatore for weddings, corporate events, and parties with customizable menus."
        />
      </Helmet>

      <h1>Professional Catering Services in Coimbatore</h1>

      <p>
        Sevvur Pandiyan Catering offers premium catering services in Coimbatore
        for corporate events, weddings, and private parties.
      </p>

      <h2>Our Catering Solutions</h2>
      <ul>
        <li>Corporate Catering Services</li>
        <li>Wedding Catering</li>
        <li>Outdoor Catering</li>
        <li>Veg and Non-Veg Catering</li>
      </ul>

      <h2>Why Choose Us?</h2>
      <p>
        We provide high-quality food, timely service, and customizable menus to
        meet your event needs.
      </p>

      <h2>Contact Us</h2>
      <p>Book catering services in Coimbatore today!</p>
    </div>
  );
}

export default Coimbatore;